/*
 * Picturepops onboarding — IndexedDB wrapper for local-upload photo blobs.
 * localStorage caps at ~5MB per origin, which four builder photos can blow
 * as base64. IndexedDB has hundreds of MB budget and stores Blobs natively.
 *
 * Exposes:
 *   PP.idb.put(key, blob) → Promise<void>
 *   PP.idb.get(key)       → Promise<Blob | null>
 *   PP.idb.delete(key)    → Promise<void>
 *   PP.idb.clear()        → Promise<void>  (removes all pp_photos entries)
 */
(function () {
  'use strict';
  window.PP = window.PP || {};

  var DB_NAME = 'pp_photos';
  var DB_VERSION = 1;
  var STORE = 'blobs';

  function openDb() {
    return new Promise(function (resolve, reject) {
      var req = indexedDB.open(DB_NAME, DB_VERSION);
      req.onupgradeneeded = function () {
        var db = req.result;
        if (!db.objectStoreNames.contains(STORE)) db.createObjectStore(STORE);
      };
      req.onsuccess = function () { resolve(req.result); };
      req.onerror = function () { reject(req.error); };
    });
  }

  function tx(mode, run) {
    return openDb().then(function (db) {
      return new Promise(function (resolve, reject) {
        var t = db.transaction(STORE, mode);
        var store = t.objectStore(STORE);
        var result;
        run(store, function (r) { result = r; });
        t.oncomplete = function () { resolve(result); };
        t.onerror = function () { reject(t.error); };
        t.onabort = function () { reject(t.error); };
      });
    });
  }

  function put(key, blob) {
    return tx('readwrite', function (store) { store.put(blob, key); });
  }

  function get(key) {
    return tx('readonly', function (store, setResult) {
      var r = store.get(key);
      r.onsuccess = function () { setResult(r.result || null); };
    });
  }

  function del(key) {
    return tx('readwrite', function (store) { store.delete(key); });
  }

  function clear() {
    return tx('readwrite', function (store) { store.clear(); });
  }

  window.PP.idb = { put: put, get: get, delete: del, clear: clear };
})();
